/**
 * Turning a pasted block of text into a list of story titles. Hosts paste out of
 * a tracker, a spreadsheet or a notes app, so the input arrives with whatever
 * list markers that tool uses.
 */

/** A leading bullet or ordinal, e.g. `- `, `* `, `• `, `1. `, `2) `. */
const LIST_MARKER = /^\s*(?:[-*•]\s*|\d+[.)]\s*)/;

/**
 * One story per line. Blank lines and lines that are nothing but a marker are
 * dropped. A ticket key at the front of a title is left alone — it is the most
 * useful part of the line to read back in the log.
 */
export function parseStoryList(text: string): string[] {
  return text
    .split(/\r?\n/)
    .map((line) => line.replace(LIST_MARKER, '').trim())
    .filter((line) => line.length > 0);
}
